import {fetcher} from '#lit/utils/http.js';
import {RequestMethod} from '#lit/common/constants/index.js';
import {getCSRFToken} from '#lit/utils/auth.js';
import {displayApiError} from '#lit/utils/notifications.js';

export type DownloadType = 'Audience' | 'Journey';

export async function download(
  items: Set<number>,
  type: DownloadType,
  fileName: string
): Promise<void> {
  try {
    const blob = await fetchDataToDownload(Array.from(items), type);

    downloadData(blob, fileName);
  } catch (e) {
    if (e instanceof Blob) {
      const errorText = await e.text();
      displayApiError(errorText);
    } else {
      displayApiError(e);
    }
  }
}

async function fetchDataToDownload(
  items: number[],
  type: 'Audience' | 'Journey'
): Promise<Blob> {
  const url = '/api/v2/bulk_actions/update';
  const response: Blob = await fetcher(url, {
    method: RequestMethod.PATCH,
    body: {
      model: type,
      operation: 'export',
      ids: items,
    },
    headers: CSRFHeader(),
    responseParser: 'blob',
  });

  return response;
}

function downloadData(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function CSRFHeader() {
  return {
    'X-CSRF-Token': getCSRFToken(),
  };
}
